// Approximate route polylines for the Fjällsjö trail network.
// Coordinates are hand-traced from backe.nu/vandringseldorado PDF-map
// combined with visible paths in OpenStreetMap. Accuracy ±50-150m.
//
// Format: { slug, name, color, coords: [[lng, lat], ...] }

import { trailSlug } from "./trails";

const mk = (name, color, coords) => ({ slug: trailSlug(name), name, color, coords });

export const TRAIL_ROUTES = [
  // === BACKE ===
  mk("Stigen runt Backsjön", "#B07128", [
      [16.4095, 63.8120],
      [16.4102, 63.8132],
      [16.4085, 63.8148],
      [16.4053, 63.8152],
      [16.4028, 63.8142],
      [16.4018, 63.8125],
      [16.4028, 63.8110],
      [16.4055, 63.8102],
      [16.4085, 63.8108],
      [16.4095, 63.8120],
  ]),
  mk("Flottarstigen", "#3F6B4E", [
      [16.4050, 63.8106],
      [16.4078, 63.8118],
      [16.4110, 63.8133],
      [16.4145, 63.8148],
      [16.4180, 63.8160],
      [16.4215, 63.8173],
      [16.4248, 63.8180],
  ]),
  mk("Kläppstigen", "#3F6B4E", [
      [16.4055, 63.8110],
      [16.4030, 63.8125],
      [16.4010, 63.8138],
      [16.3990, 63.8150],
  ]),
  mk("Elljusspåret", "#3F6B4E", [
      [16.4050, 63.8090],
      [16.4030, 63.8078],
      [16.4005, 63.8065],
      [16.3985, 63.8075],
      [16.3998, 63.8092],
      [16.4025, 63.8098],
      [16.4050, 63.8090],
  ]),

  // === JANSJÖ ===
  mk("Flobergsstigen", "#3F6B4E", [
      [16.3720, 63.8370],
      [16.3695, 63.8385],
      [16.3665, 63.8398],
      [16.3638, 63.8405],
      [16.3615, 63.8420],
  ]),
  mk("Djuptjärnsstigen", "#8E2816", [
      [16.3600, 63.8400],
      [16.3605, 63.8418],
      [16.3618, 63.8438],
      [16.3625, 63.8460],
      [16.3630, 63.8482],
      [16.3615, 63.8502],
      [16.3590, 63.8515],
      [16.3560, 63.8528],
      [16.3530, 63.8540],
      [16.3500, 63.8550],
  ]),
  mk("Lidtjärnstigen", "#3F6B4E", [
      [16.3580, 63.8358],
      [16.3555, 63.8375],
      [16.3540, 63.8395],
  ]),
  mk("Gammrågan", "#3F6B4E", [
      [16.3625, 63.8380],
      [16.3645, 63.8395],
      [16.3670, 63.8410],
      [16.3695, 63.8405],
      [16.3720, 63.8395],
      [16.3735, 63.8380],
      [16.3720, 63.8368],
      [16.3690, 63.8365],
      [16.3655, 63.8370],
      [16.3625, 63.8380],
  ]),
  mk("Benknäckarn", "#6b2a6b", [
      [16.3605, 63.8385],
      [16.3590, 63.8408],
      [16.3580, 63.8432],
      [16.3595, 63.8450],
      [16.3615, 63.8440],
      [16.3610, 63.8415],
      [16.3605, 63.8395],
      [16.3605, 63.8385],
  ]),
  mk("Landsomberget (vandring)", "#3F6B4E", [
      [16.3533, 63.8444],
      [16.3540, 63.8455],
      [16.3548, 63.8468],
      [16.3555, 63.8480],
  ]),
];

// Snöskoterleder (approx från OSM + Skotersällskapet Tre Kommuner).
export const SKOTER_ROUTES = [
  mk("Skoterled Backe ↔ Rossön (huvud)", "#4a6075", [
      [16.4058, 63.8107],
      [16.4012, 63.8185],
      [16.3928, 63.8280],
      [16.3820, 63.8420],
      [16.3695, 63.8580],
      [16.3545, 63.8745],
      [16.3405, 63.8895],
      [16.3387, 63.9087],
      [16.3387, 63.9228],
  ]),
  mk("Skoterled Backe ↔ Junsele", "#4a6075", [
      [16.4058, 63.8107],
      [16.4150, 63.8050],
      [16.4280, 63.7950],
      [16.4420, 63.7830],
      [16.4580, 63.7690],
      [16.4720, 63.7555],
  ]),
];

export function findRouteBySlug(slug) {
  return TRAIL_ROUTES.find(r => r.slug === slug);
}
